import { createContext } from "react";

const videoContext = createContext();

export default videoContext;